import React, { PureComponent, ReactNode } from "react";
import { AppContextType } from "../../../AppContext";
import IconButton from "../../theme_reuse/IconButton";
import { ICON_SCROLLING } from "../../../constants/iconConstants";

interface Props {}
interface State {}

export default class HistoryAutoScrollButton extends PureComponent<Props, State> {
  declare context: React.ContextType<typeof AppContextType>;
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  toggleSetting = () => {
    const autoScroll = !this.context.chordHistoryOptions.autoScroll;
    this.context.dispatch({ type: "EditChordHistoryOptions", payload: { autoScroll } });
  };

  render(): ReactNode {
    const autoScroll = this.context.chordHistoryOptions.autoScroll;
    return (
      <IconButton
        mini
        title={autoScroll ? "Autoscroll On" : "Autoscroll Off"}
        icon={ICON_SCROLLING}
        strikethrough={!autoScroll}
        onClick={this.toggleSetting}
      />
    );
  }
}

HistoryAutoScrollButton.contextType = AppContextType;
